import { useEffect, useState } from 'react'
import { Dropdown, Form } from 'react-bootstrap'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import Header from '../componets/Layout/Header'
import Sidebar from '../componets/Layout/Sidebar'
import MultipleSelected from '../componets/MultipleSelected'
import { PricingPlanValidateFields } from '../componets/validate/priceValidation'
import { editPlans, getCategoryAll, getTemplateByCategories } from '../controller'
import { requestHandler } from '../helper'
import SingleError from '../helper/SingleError'

function PricingPlan() {

    const [errors, setErrors] = useState({});
    const location = useLocation();
    const state = location?.state?.planData || {};
    const navigate = useNavigate();
    const [data, setData] = useState({
        plan_type: state.plan_type || '',
        time_limit: state.time_limit || 0,
        limits: state.limits || 0,
        bundle: state.bundle || [
            {
                category_id: state.category,
                template_id: [state.template],
            },
        ],
    });


    const [selectedCategories, setSelectedCategories] = useState({});
    const [categoryData, setCategoryData] = useState([]);
    const [tempData, setTempData] = useState([]);
    const [activeDropdowns, setActiveDropdowns] = useState({});


    // Add a new bundle (category + template dropdown)
    const handleAdd = () => {
        setData({
            ...data,
            bundle: [
                ...data.bundle,
                {
                    category_id: '',
                    template_id: [],
                },
            ],
        });
    };

    // Remove a bundle
    const handleRemove = (index) => {
        const updatedBundle = data.bundle.filter((_, i) => i !== index);
        setData({
            ...data,
            bundle: updatedBundle,
        });
    };

    const getCategoryData = async () => {
        await requestHandler(
            async () => await getCategoryAll(true),
            null,
            (res) => {
                const { category } = res.data;
                setCategoryData(category);
            },
            () => { }
        );
    };

    useEffect(() => {
        getCategoryData();
    }, []); //


    const getTempData = async (categoryId, index) => {
        await requestHandler(
            async () => await getTemplateByCategories(categoryId),
            null,
            (res) => {
                const updatedBundle = [...data.bundle];
                setData({
                    ...data,
                    bundle: updatedBundle,
                });
                setTempData(res.data.templates);
            },
            () => { }
        );
    };

    const handleCategoryChange = (categoryId, index, selectedCategory) => {
        const updatedBundle = [...data.bundle];
        const isSameCategory = updatedBundle[index].category_id._id === categoryId;
        updatedBundle[index].category_id = { _id: categoryId, name: selectedCategory };

        setSelectedCategories({
            ...selectedCategories,
            [index]: selectedCategory,
        });
        if (!isSameCategory) {
            updatedBundle[index].template_id = []; // Reset templates for this bundle
        }

        // Clear the category error for this bundle index
        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if (newErrors.bundle && newErrors.bundle[index]) {
                delete newErrors.bundle[index].category_id;
            }
            return newErrors;
        });

        setData({
            ...data,
            bundle: updatedBundle,
        });

        setActiveDropdowns({ [index]: index || 0 });
        getTempData(categoryId, index); // Fetch templates for the selected category
    };



    // Handle template change for a specific bundle
    const handleTemplateChange = (selectedTemplate, index) => {
        const updatedBundle = [...data.bundle];
        const selectedTemplates = updatedBundle[index].template_id || [];

        const isSelected = selectedTemplates.some((template) => template._id === selectedTemplate._id);

        if (isSelected) {
            updatedBundle[index].template_id = selectedTemplates.filter((template) => template._id !== selectedTemplate._id);
        } else {
            updatedBundle[index].template_id = [...selectedTemplates, selectedTemplate];
        }
        // Clear the template error for this bundle index
        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if (newErrors.bundle && newErrors.bundle[index]) {
                delete newErrors.bundle[index].template_id;
            }
            return newErrors;
        });

        setData({
            ...data,
            bundle: updatedBundle,
        });
    };

    const handleSave = async (e) => {
        e.preventDefault();
        let validationErrors = PricingPlanValidateFields(data);
        setErrors(validationErrors);
        let allTemplateIds = [];

        data.bundle.forEach(bundle => {
            allTemplateIds = [...allTemplateIds, ...bundle.template_id];
        });
        if (allTemplateIds.length > data.limits) {
            toast.error(`The total number of templates should be equal to ${data.limits}.`);
            return;
        }


        if (Object.keys(validationErrors).length === 0) {
            // Submit the form data if there are no validation errors
            await requestHandler(
                async () => await editPlans(data, state._id),
                null,
                (res) => {
                    toast.success("Plan updated successfully");
                    navigate('/pricing-details');
                },
                (err) => {
                    toast.error("Failed to update the plan");
                }
            );
        }
    };


    return (
        <>
            <div className='layouy-main'>
                <div className='sidebar-hide-show'>
                    <Sidebar />
                </div>
                <div className='w-100'>
                    <Header />
                    <div className="tebs-title">
                        <p className='active'>Subscription Pricing plan</p>
                    </div>
                    <section>
                        <div className="card main-card">
                            <div className="card modal-form pt-0">
                                <div class="card-header bg-transparent p-3">
                                    <div class="d-flex flex-column flex-md-row gap-3 justify-content-between align-items-start align-items-md-center">
                                        <h4 class="add-title">Subscription Pricing plan</h4>
                                        <Link class="back-btn d-flex align-items-center gap-2 text-decoration-none" to="/pricing-details">
                                            <img src="../images/png/left.png" width="10" alt="" />
                                            <p class="mb-0">Back</p>
                                        </Link>
                                    </div>
                                </div>
                                <div className="card-body h-100">
                                    <Form>
                                        <div className='row pt-0 g-3'>
                                            <div className="col-lg-6">
                                                <Form.Group controlId="formGroupEmail">
                                                    <Form.Label>Plan Type</Form.Label>
                                                    <Form.Control type="text" placeholder="Plan type" name='plan_type' value={data.plan_type} className='form-control' disabled style={{ textTransform: 'capitalize' }} />
                                                </Form.Group>
                                            </div>
                                            <div className="col-lg-6">
                                                <Form.Group controlId="formGroupEmail">
                                                    <Form.Label>Time Limit</Form.Label>
                                                    <Form.Control type="text" placeholder="Time Limit" name='time_limit' value={data.time_limit === 0 ? '3 Months' : data.time_limit === 1 ? '6 Month' : '1 Year'} className='form-control' disabled />
                                                </Form.Group>
                                            </div>
                                            <div className="col-lg-12">
                                                <Form.Group controlId="formGroupEmail">
                                                    <Form.Label>Template Limits</Form.Label>
                                                    <Form.Control type="Number" placeholder="Template Limit" min="1" name='limits' value={data.limits} onChange={(e) => setData({ ...data, limits: e.target.value })} className='form-control' />
                                                </Form.Group>
                                            </div>
                                        </div>
                                    </Form>


                                    {data.bundle.map((bundle, index) => (
                                        <div key={index}>
                                            <div className='row g-3 mt-0'>
                                                <div className="col-lg-6">
                                                    <Form.Group controlId="formGroupPassword">
                                                        <Form.Label>Category</Form.Label>
                                                        <Dropdown className='status-btn'>
                                                            <Dropdown.Toggle>
                                                                {selectedCategories[index] || bundle.category_id.name || 'Select Category'}
                                                            </Dropdown.Toggle>

                                                            <Dropdown.Menu>
                                                                {categoryData?.map(category => (
                                                                    <Dropdown.Item key={category._id} onClick={() => handleCategoryChange(category._id, index, category.name)}
                                                                        className={category._id === bundle.category_id._id ? 'selected-status' : ''}
                                                                    >
                                                                        {category.name}
                                                                    </Dropdown.Item>
                                                                ))}
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </Form.Group>
                                                    <SingleError error={errors?.bundle?.[index]?.category_id} />


                                                </div>
                                                <div className="col-lg-6">
                                                    <div className='d-flex align-items-end gap-3 w-100 template-add'>
                                                        <MultipleSelected
                                                            options={tempData}
                                                            selectedStatus={bundle.template_id}
                                                            handleSelect={(selectedTemplate) => handleTemplateChange(selectedTemplate, index)}
                                                            label="Template"
                                                            index={index}
                                                            activeDropdowns={activeDropdowns[index]}
                                                            error={errors?.bundle?.[index]?.template_id}
                                                        />

                                                        {/* Add button */}
                                                        <div className='plus_btn flex-shrink-0' onClick={() => handleAdd()}>
                                                            <img src="../images/png/plush.png" width="22" alt="" />
                                                        </div>
                                                        <div className='plus_btn flex-shrink-0' onClick={() => handleRemove(index)}>
                                                            <img src="../images/png/dustbin.png" width="22" alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <div className="col-lg-6">
                                        {data.bundle.length === 0 ? (
                                            <>
                                                <Form.Group controlId="formGroupEmail">
                                                    <Form.Label>Add Bundle</Form.Label>
                                                </Form.Group>
                                                <button className='plus_btn' onClick={() => handleAdd()}>
                                                    <img src="../images/png/plush.png" width="22" alt="" />
                                                </button>
                                            </>
                                        ) : (
                                            <div className="d-flex align-items-center justify-content-center">
                                                {/* You can add any content here to show when the bundle is not empty */}
                                            </div>
                                        )}
                                    </div>

                                    <div className='mt-3'>
                                        <button className='add-btn border-0 rounded-3' onClick={handleSave} type='button'>
                                            <p className='m-0'>Save</p>
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div >
            </div>
        </>

    )

}

export default PricingPlan;